import api from '@/api/services/api'

const getFilials = () => api({
  method: 'get',
  url: '/orders/fit/filials'
})

const createRequest = data => api({
  method: 'post',
  url: '/orders/fit',
  data
})

export {
  getFilials,
  createRequest
}